import { useEffect, useRef } from 'react';

import { Outlet, createFileRoute, useRouter } from '@tanstack/react-router';

import { Text } from '@optiro/ui';

import { useAuth } from '@/providers/AuthProvider/AuthProvider';

export const Route = createFileRoute('/admin')({
  component: AdminLayout,
});

function AdminLayout() {
  const router = useRouter();
  const { userData, isSignedIn, loading } = useAuth();

  const redirectTimeout = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (loading) return;

    if (!isSignedIn) {
      // Wait 300ms before redirecting
      redirectTimeout.current = setTimeout(() => {
        router.navigate({
          to: '/experiences/login',
          search: { notice: 'login-to-continue' },
        });
      }, 300);
    }

    return () => {
      if (redirectTimeout.current) clearTimeout(redirectTimeout.current);
    };
  }, [loading, isSignedIn, router, userData]);

  // Wait for auth state to be determined
  if (loading) {
    return null;
  }

  // Return null while redirecting to prevent rendering
  if (!isSignedIn && !loading) {
    return null;
  }

  // Render children if the user is an admin
  if (userData?.admin) {
    return <Outlet />;
  }

  // Render fallback message if the user is not an admin
  return <Text>How&apos;d you get here?</Text>;
}
